<div class="clean-input flex direction-col">
  <label data-test="lbl">
    <span data-test="txt" class="label">{{ label }}</span>
  </label>
  <mat-slide-toggle [checked]="value" (click)="checked()">{{ 'active' | translate }}</mat-slide-toggle>
</div>
